module.exports = {
    signUpForm: {
        pickupTitle: 'Click & Collect',
        pickupDescription: 'Collect your groceries from a local store for FREE',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/sign-up-form.js